import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "min-h-full" }
const _hoisted_2 = { class: "p-4" }
const _hoisted_3 = { class: "space-y-6" }
const _hoisted_4 = { class: "bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6" }
const _hoisted_5 = { class: "md:grid md:grid-cols-3 md:gap-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "md:col-span-1" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-medium leading-6 text-gray-900" }, " プロフィール ")
], -1)
const _hoisted_7 = { class: "mt-5 md:mt-0 md:col-span-2" }
const _hoisted_8 = {
  class: "space-y-6",
  action: "#",
  method: "POST"
}
const _hoisted_9 = { class: "mt-1 flex items-center space-x-5" }
const _hoisted_10 = {
  key: 0,
  class: "inline-block h-12 w-12 rounded-full overflow-hidden bg-gray-100"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-full w-full text-gray-300",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" })
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "grid grid-cols-6 gap-6" }
const _hoisted_15 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "first-name",
  class: "block text-sm font-medium text-gray-700"
}, "苗字", -1)
const _hoisted_17 = {
  key: 0,
  class: "text-xs text-pink-600"
}
const _hoisted_18 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "last-name",
  class: "block text-sm font-medium text-gray-700"
}, "名前", -1)
const _hoisted_20 = {
  key: 0,
  class: "text-xs text-pink-600"
}
const _hoisted_21 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  for: "first-name",
  class: "block text-sm font-medium text-gray-700"
}, "苗字カナ", -1)
const _hoisted_23 = {
  key: 0,
  class: "text-xs text-pink-600"
}
const _hoisted_24 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  for: "last-name",
  class: "block text-sm font-medium text-gray-700"
}, "名前カナ", -1)
const _hoisted_26 = {
  key: 0,
  class: "text-xs text-pink-600"
}
const _hoisted_27 = { class: "col-span-6 sm:col-span-3 lg:col-span-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  for: "postal-code",
  class: "block text-sm font-medium text-gray-700"
}, "郵便番号", -1)
const _hoisted_29 = {
  key: 0,
  class: "text-xs text-pink-600"
}
const _hoisted_30 = { class: "col-span-6 sm:col-span-3 lg:col-span-2" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", {
  for: "country",
  class: "block text-sm font-medium text-gray-700"
}, "都道府県", -1)
const _hoisted_32 = ["value"]
const _hoisted_33 = {
  key: 0,
  class: "text-xs text-pink-600"
}
const _hoisted_34 = { class: "col-span-6 sm:col-span-6 lg:col-span-2" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", {
  for: "city",
  class: "block text-sm font-medium text-gray-700"
}, "市区町村", -1)
const _hoisted_36 = {
  key: 0,
  class: "text-xs text-pink-600"
}
const _hoisted_37 = { class: "col-span-6" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", {
  for: "street-address",
  class: "block text-sm font-medium text-gray-700"
}, "住所", -1)
const _hoisted_39 = {
  key: 0,
  class: "text-xs text-pink-600"
}
const _hoisted_40 = { class: "col-span-6" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", {
  for: "street-address",
  class: "block text-sm font-medium text-gray-700"
}, "建物", -1)
const _hoisted_42 = {
  key: 0,
  class: "text-xs text-pink-600"
}
const _hoisted_43 = { class: "col-span-6 sm:col-span-3" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", {
  for: "telephone",
  class: "block text-sm font-medium text-gray-700"
}, "電話番号", -1)
const _hoisted_45 = {
  key: 0,
  class: "text-xs text-pink-600"
}
const _hoisted_46 = { class: "flex justify-end" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  key: 0,
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_50 = { class: "fixed z-10 inset-0 overflow-y-auto" }
const _hoisted_51 = { class: "flex items-center justify-center min-h-full p-4 text-center sm:p-0" }
const _hoisted_52 = { class: "relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-sm sm:w-full sm:p-6" }
const _hoisted_53 = { class: "flex justify-center items-center" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "grow" }, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, "保存しました", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "grow" }, null, -1)

import * as yup from "yup";
import { useField, useForm, FieldContext } from "vee-validate";
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { uuid } from "vue-uuid";

import { Auth, Storage } from "aws-amplify";
import AddressUtil from "@/utils/AddressUtil";
import Prefecture from "@/models/Prefecture";
import Customer from "@/models/Customer";
// import { Options, Vue } from "vue-class-component";
// import AddressUtil from "../utils/AddressUtil";

// import { Storage } from "aws-amplify";
// import { uuid } from "vue-uuid";

import AppHeader from "@/components/AppHeader.vue";
// import Customer from "../models/Customer";
// import Prefecture from "../models/Prefecture";
// import ValidationUtil from "@/utils/ValidationUtil";

// @Options({
//   components: {
//     AppHeader,
//   },
// })
// export default class EditProfileView extends Vue {


export default /*#__PURE__*/_defineComponent({
  __name: 'EditProfileView',
  setup(__props) {

const store = useStore();
const route = useRoute();

const formSchema = yup.object({
  selfie_image_url: yup.string().required("必須項目です"),
  family_name: yup.string().required("必須項目です"),
  given_name: yup.string().required("必須項目です"),
  family_name_kana: yup.string().kana().required("必須項目です"),
  given_name_kana: yup.string().kana().required("必須項目です"),
  postcode: yup.string().postcode(),
  prefecture: yup.string(),
  city: yup.string(),
  address: yup.string(),
  building: yup.string(),
  telephone: yup.string().phonenumber(),
});

useForm({ validationSchema: formSchema });

const selfie_image_url_field = useField<string>("main_image_url");
const family_name_field = useField<string>("family_name");
const given_name_field = useField<string>("given_name");
const family_name_kana_field = useField<string>("family_name_kana");
const given_name_kana_field = useField<string>("given_name_kana");
const postcode_field = useField<string>("postcode");
const prefecture_field = useField<string>("prefecture");
const city_field = useField<string>("city");
const address_field = useField<string>("address");
const building_field = useField<string>("building");
const telephone_field = useField<string>("telephone");

const selfie_image_url = selfie_image_url_field.value;
const selfie_image_url_error = selfie_image_url_field.errorMessage;

const family_name = family_name_field.value;
const family_name_error = family_name_field.errorMessage;

const given_name = given_name_field.value;
const given_name_error = given_name_field.errorMessage;

const family_name_kana = family_name_kana_field.value;
const family_name_kana_error = family_name_kana_field.errorMessage;

const given_name_kana = given_name_kana_field.value;
const given_name_kana_error = given_name_kana_field.errorMessage;

const postcode = postcode_field.value;
const postcode_error = postcode_field.errorMessage;

const prefecture = prefecture_field.value;
const prefecture_error = prefecture_field.errorMessage;

const prefectures = ref<Prefecture[]>([]);

const city = city_field.value;
const city_error = city_field.errorMessage;

const address = address_field.value;
const address_error = address_field.errorMessage;

const building = building_field.value;
const building_error = building_field.errorMessage;

const telephone = telephone_field.value;
const telephone_error = telephone_field.errorMessage;

const show_confirm = ref<boolean>(false);

const refresh = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      prefectures.value = Prefecture.all();

      selfie_image_url.value = store.state.customer.selfie_image_url;
      family_name.value = store.state.customer.family_name ?? "";
      family_name_kana.value = store.state.customer.family_name_kana ?? "";
      given_name.value = store.state.customer.given_name ?? "";
      given_name_kana.value = store.state.customer.given_name_kana ?? "";
      postcode.value = store.state.customer.postcode ?? "";
      prefecture.value = store.state.customer.prefecture ?? "";
      city.value = store.state.customer.city ?? "";
      address.value = store.state.customer.address ?? "";
      building.value = store.state.customer.building ?? "";
      telephone.value = store.state.customer.telephone ?? "";
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const selfie_image_url_input = ref<HTMLInputElement>();

const selectImage = () => {
  const input = selfie_image_url_input.value;
  input?.click();
};

const onFileChanged = () => {
  const input = selfie_image_url_input.value;
  if (!input?.files) {
    return;
  }
  const file = input.files[0];
  const split = file.name.split(".");
  const filename = uuid.v4();
  const extension = split[split.length - 1];
  const contentType = extension == "png" ? "image/png" : "image/jpg";

  setTimeout(async () => {
    Storage.configure({ customPrefix: { public: "customers" } });
    const s3response = await Storage.put(`/${filename}.${extension}`, file, {
      contentType: contentType,
    });

    // console.log(s3response);

    selfie_image_url.value = `${process.env.VUE_APP_HOST}/customers/${filename}.${extension}`;
    // console.log(selfie_image_url.value);
  });
};

const onPostcodeChanged = () => {
  // console.log(`${postcode.value}`);

  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const result = await AddressUtil.search(postcode.value);
      if (!result || result.length == 0) {
        return;
      }

      const data = result[0] as any;

      const match = Prefecture.all().find(
        (p) => p.name == data.pref
      ) as Prefecture | null;

      prefecture.value = match ? match.name : "";

      city.value = data.city as string;
      address.value = data.town as string;
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const validate = async (): Promise<boolean> => {
  await selfie_image_url_field.validate();
  await family_name_field.validate();
  await given_name_field.validate();
  await family_name_kana_field.validate();
  await given_name_kana_field.validate();
  await postcode_field.validate();
  await prefecture_field.validate();
  await city_field.validate();
  await address_field.validate();
  await building_field.validate();
  await telephone_field.validate();

  return (
    !family_name_error.value &&
    !given_name_error.value &&
    !family_name_kana_error.value &&
    !given_name_kana_error.value &&
    !postcode_error.value &&
    !prefecture_error &&
    !city_error &&
    !address_error &&
    !building_error &&
    !telephone_error
  );
};

const doSave = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      if (!store.state.customer) {
        return;
      }
      const valid = await validate();
      if (!valid) {
        return;
      }
      await Customer.update(
        store.state.customer!.id,
        "",
        selfie_image_url.value,
        store.state.customer!.email,
        family_name.value,
        given_name.value,
        family_name_kana.value,
        given_name_kana.value,
        postcode.value,
        prefecture.value,
        city.value,
        address.value,
        building.value,
        telephone.value
      );

      store.dispatch("refreshUser");

      show_confirm.value = true;
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

onMounted(() => {
  refresh();
});

return (_ctx: any,_cache: any) => {
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("form", _hoisted_8, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_9, [
                      (!_unref(selfie_image_url))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _hoisted_12))
                        : _createCommentVNode("", true),
                      (_unref(selfie_image_url))
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: _unref(selfie_image_url),
                            class: "inline-block h-12 w-12 rounded-full overflow-hidden bg-gray-100"
                          }, null, 8, _hoisted_13))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        type: "button",
                        class: "bg-white py-2 px-3 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                        onClick: selectImage
                      }, " 変更 "),
                      _createElementVNode("input", {
                        ref_key: "selfie_image_url_input",
                        ref: selfie_image_url_input,
                        type: "file",
                        style: {"display":"none"},
                        accept: "image/png, image/jpeg",
                        onChange: onFileChanged
                      }, null, 544)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "first-name",
                        id: "first-name",
                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(family_name) ? (family_name).value = $event : null))
                      }, null, 512), [
                        [_vModelText, _unref(family_name)]
                      ]),
                      (_unref(family_name_error))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(family_name_error) || ""), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "last-name",
                        id: "last-name",
                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(given_name) ? (given_name).value = $event : null))
                      }, null, 512), [
                        [_vModelText, _unref(given_name)]
                      ]),
                      (_unref(given_name_error))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_unref(given_name_error) || ""), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "first-name",
                        id: "first-name",
                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(family_name_kana) ? (family_name_kana).value = $event : null))
                      }, null, 512), [
                        [_vModelText, _unref(family_name_kana)]
                      ]),
                      (_unref(family_name_kana_error))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_unref(family_name_kana_error) || ""), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "last-name",
                        id: "last-name",
                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(given_name_kana) ? (given_name_kana).value = $event : null))
                      }, null, 512), [
                        [_vModelText, _unref(given_name_kana)]
                      ]),
                      (_unref(given_name_kana_error))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_unref(given_name_kana_error) || ""), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "postal-code",
                        id: "postal-code",
                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(postcode) ? (postcode).value = $event : null)),
                        onChange: onPostcodeChanged
                      }, null, 544), [
                        [_vModelText, _unref(postcode)]
                      ]),
                      (_unref(postcode_error))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_unref(postcode_error) || ""), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _withDirectives(_createElementVNode("select", {
                        id: "country",
                        name: "country",
                        class: "mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(prefecture) ? (prefecture).value = $event : null))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prefectures.value, (p) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: p.code,
                            value: p.name
                          }, _toDisplayString(p.name), 9, _hoisted_32))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _unref(prefecture)]
                      ]),
                      (_unref(prefecture_error))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_unref(prefecture_error) || ""), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "city",
                        id: "city",
                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(city) ? (city).value = $event : null))
                      }, null, 512), [
                        [_vModelText, _unref(city)]
                      ]),
                      (_unref(city_error))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_unref(city_error) || ""), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "street-address",
                        id: "street-address",
                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(address) ? (address).value = $event : null))
                      }, null, 512), [
                        [_vModelText, _unref(address)]
                      ]),
                      (_unref(address_error))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_unref(address_error) || ""), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _hoisted_41,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "street-address",
                        id: "street-address",
                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(building) ? (building).value = $event : null))
                      }, null, 512), [
                        [_vModelText, _unref(building)]
                      ]),
                      (_unref(building_error))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_unref(building_error) || ""), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "telephone",
                        id: "telephone",
                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(telephone) ? (telephone).value = $event : null))
                      }, null, 512), [
                        [_vModelText, _unref(telephone)]
                      ]),
                      (_unref(telephone_error))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_unref(telephone_error) || ""), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("button", {
              type: "submit",
              class: "ml-3 mb-4 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-color-2",
              onClick: _withModifiers(doSave, ["prevent"])
            }, " 保存 ", 8, _hoisted_47)
          ])
        ])
      ])
    ]),
    (show_confirm.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
          _hoisted_49,
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_53, [
                    _hoisted_54,
                    _hoisted_55,
                    _hoisted_56,
                    _createElementVNode("button", {
                      class: "ml-8 flex items-center justify-center h-8 w-8 rounded-full",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (show_confirm.value = false))
                    }, [
                      _createVNode(_component_fa, { icon: "times" })
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})